var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamcard2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8333 49.745V42.6667C46.8333 42.6667 42.6667 40.1667 36 40.1667C29.3333 40.1667 25.1667 42.6667 25.1667 42.6667V49.745M18.5 36C18.5 26.335 26.335 18.5 36 18.5C45.665 18.5 53.5 26.335 53.5 36C53.5 45.665 45.665 53.5 36 53.5C26.335 53.5 18.5 45.665 18.5 36ZM30.1667 29.3333C30.1667 33.7683 35.7983 36.7917 35.8767 36.8333H35.8817H36.1183H36.1233C36.2017 36.7917 41.8333 33.7683 41.8333 29.3333C41.8333 26.1117 39.2333 23.5 36.0067 23.5C35.2402 23.4996 34.4811 23.6501 33.7728 23.943C33.0645 24.2359 32.4208 24.6655 31.8785 25.2072C31.3362 25.7488 30.906 26.392 30.6122 27.1C30.3185 27.808 30.1671 28.5669 30.1667 29.3333Z",
    stroke: "url(#paint0_linear_708_8439)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_708_8439",
    x1: 18.5,
    y1: 36,
    x2: 53.5,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamcard2);
export default __webpack_public_path__ + "static/media/teamcard-2.b7e6ace8451d37db525085f0adea9d98.svg";
export { ForwardRef as ReactComponent };